<template>
  <BaseModal @close="$emit('close')">
    <template v-slot:title>Compartilhar via WhatsApp</template>
    
    <div class="share-content" v-if="shareData">
      <div class="context-box" :class="shareData.contextType">
        <span class="material-icons-outlined icon-context">
          {{ shareData.contextType === 'review' ? 'star' : (shareData.contextType === 'warning' ? 'warning' : 'check_circle') }}
        </span>
        <div>
          <strong>{{ shareData.contextTitle }}</strong>
          <p>{{ shareData.contextDesc }}</p>
        </div>
      </div>
      
      <div v-if="pedido.status === 'approved'" class="date-selector-container">
        <label class="date-label">
          Previsão de Entrega:
        </label>
        
        <div class="custom-date-wrapper">
          <input
            type="text"
            class="input-date-display"
            :value="formattedDisplayDate"
            placeholder="dd/mm/aaaa"
            readonly
          >
          
          <span class="material-icons-outlined icon-calendar">event</span>
          
          <input
            type="date"
            v-model="deliveryDate"
            :min="minDate"
            class="input-date-hidden"
            @input="generateShareData"
            @click="triggerDatePicker"
          >
        </div>
      </div>
      
      <div class="share-actions-grid">
        <button class="share-option-btn" @click="copyToClipboard(shareData.link, 'Link copiado!')">
          <span class="material-icons-outlined">link</span>
          <span>Copiar Link</span>
        </button>
        
        <button class="share-option-btn" @click="copyToClipboard(shareData.message, 'Mensagem copiada!')">
          <span class="material-icons-outlined">content_copy</span>
          <span>Copiar Mensagem</span>
        </button>
        
        <button class="share-option-btn whatsapp" @click="openWhatsApp">
          <span class="material-icons-outlined">open_in_new</span>
          <span>Abrir WhatsApp</span>
        </button>
      </div>
      
<!--      <div class="message-preview">-->
<!--        <small>Prévia da mensagem:</small>-->
<!--        <div class="preview-box">{{ shareData.message }}</div>-->
<!--      </div>-->
    
    </div>
    <div v-else class="loading-state">Gerando link...</div>
    
    <template v-slot:actions>
      <button @click="$emit('close')" class="modal-btn-no">Cancelar</button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import { AlertBus } from '@/plugins/AlertBus.js';

export default {
  name: "ModalCompartilhar",
  components: { BaseModal },
  props: {
    pedido: { type: Object, required: true }
  },
  data() {
    return {
      shareData: null,
      deliveryDate: ''
    };
  },
  computed: {
    minDate() {
      return new Date().toISOString().split('T')[0];
    },
    formattedDisplayDate() {
      if (!this.deliveryDate) return '';
      return this.formatDateBr(this.deliveryDate);
    }
  },
  mounted() {
    this.generateShareData();
  },
  methods: {
    // Força a abertura do calendário via JS (Suporte extra para Firefox/Chrome modernos)
    triggerDatePicker(event) {
      if (event.target && typeof event.target.showPicker === 'function') {
        try {
          event.target.showPicker();
        } catch (error) {
          // Ignora erro se o browser bloquear ou não suportar
        }
      }
    },
    
    formatDateBr(dateString) {
      if (!dateString) return '';
      const parts = dateString.split('-');
      if (parts.length !== 3) return dateString;
      const [ano, mes, dia] = parts;
      return `${dia}/${mes}/${ano}`;
    },
    
    formatDateFriendly(dateString) {
      if (!dateString) return '';
      
      // Fixa meio-dia para evitar problemas de fuso horário
      const targetDate = new Date(`${dateString}T12:00:00`);
      // Datas de referência (zeradas/meio-dia para comparação segura)
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
      const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 12, 0, 0);
      // 1. Gera a formatação padrão primeiro (ex: "quarta-feira, 03/12")
      const options = { weekday: 'long', day: 'numeric', month: 'numeric' };
      const baseString = targetDate.toLocaleDateString('pt-BR', options);
      // Capitaliza a primeira letra (ex: "Quarta-feira, 03/12")
      const formatted = baseString.charAt(0).toUpperCase() + baseString.slice(1);
      // 2. Concatena o prefixo se for Hoje ou Amanhã
      if (targetDate.getTime() === today.getTime()) {
        return `Hoje, ${formatted}`;
      }
      if (targetDate.getTime() === tomorrow.getTime()) {
        return `Amanhã, ${formatted}`;
      }
      return formatted;
    },
    
    generateShareData() {
      const baseUrl = window.location.origin;
      const status = this.pedido.status;
      const telefoneRaw = this.pedido.telefone || '';
      const phoneNumber = `55${telefoneRaw.replace(/\D/g, '')}`;
      const firstName = this.pedido.nome ? this.pedido.nome.split(' ')[0] : 'Cliente';
      const produtoNome = this.pedido.produto ? this.pedido.produto.nome : 'seu pedido';
      
      let link = '';
      let message = '';
      let contextTitle = '';
      let contextDesc = '';
      let contextType = '';
      
      if (status === 'delivered') {
        contextTitle = 'Solicitar Avaliação';
        contextDesc = 'O pedido foi entregue. Peça um feedback!';
        contextType = 'review';
        link = `${baseUrl}/#/avaliar?ref=${this.pedido.external_reference}`;
        message = `Olá ${firstName}! 🤠\n\nVi que a entrega de *${produtoNome}* foi concluída. Espero que tenha gostado!\n\nSe puder, deixe uma avaliação rápida no link abaixo. Ajuda muito a gente: ⭐\n${link}`;
      }
      else if (status === 'approved') {
        contextTitle = 'Confirmar Recebimento';
        contextDesc = 'Tranquilize o cliente confirmando que o pedido está garantido.';
        contextType = 'success';
        link = `${baseUrl}/#/success?external_reference=${this.pedido.external_reference}`;
        
        message = `Olá ${firstName}! Recebemos seu pedido de *${produtoNome}*! 🎉\n\nJá estamos separando tudo por aqui.`;
        
        if (this.deliveryDate) {
          const dataBonita = this.formatDateFriendly(this.deliveryDate);
          message += `\n\n🚚 *Previsão de entrega:* ${dataBonita}.`;
        }
        
        message += `\n\nVocê pode acompanhar o status neste link:\n${link}`;
      } else if (status === 'expired') {
        contextTitle = 'Recuperar Venda (Expirado)';
        contextDesc = 'O link de pagamento venceu. Ofereça ajuda.';
        contextType = 'warning';
        link = `${baseUrl}/#/`;
        message = `Oi ${firstName}, tudo bem? 🤠\n\nVi que seu pedido de *${produtoNome}* acabou expirando.\n\nDeu algum problema no pagamento ou desistiu? Se quiser tentar novamente, é só acessar a loja:\n${link}\n\nQualquer dúvida, estou à disposição!`;
      } else if (['failure', 'rejected', 'cancelled', 'refunded'].includes(status)) {
        contextTitle = 'Auxiliar no Pagamento';
        contextDesc = 'O pedido não foi concluído ou foi estornado. Ofereça ajuda.';
        contextType = 'warning';
        link = `${baseUrl}/#/`;
        message = `Oi ${firstName}! Notei que houve um problema com o pagamento do seu pedido de *${produtoNome}*. 😕\n\nO cartão não passou ou foi o Pix? Se precisar de ajuda ou quiser tentar outro meio, me avise! Ou tente novamente aqui:\n${link}`;
      } else if (status === 'out_of_stock') {
        contextTitle = 'Avisar Reposição';
        contextDesc = 'Informe que o produto chegou.';
        contextType = 'info';
        link = `${baseUrl}/#/`;
        message = `Olá ${firstName}! Tenho ótimas notícias! \n\nLembra que você queria *${produtoNome}* e estava em falta? Acabou de chegar reposição!\n\nGaranta o seu antes que acabe de novo:\n${link}`;
      } else if (status === 'in_process') {
        contextTitle = 'Avisar sobre Análise';
        contextDesc = 'O pagamento está em análise no banco. Peça para aguardar.';
        contextType = 'info';
        link = `${baseUrl}/#/pending?external_reference=${this.pedido.external_reference}`;
        message = `Oi ${firstName}! Vi aqui que seu pedido de *${produtoNome}* está em análise de segurança pelo banco/cartão.\n\nFique tranquilo(a), isso é normal e costuma liberar em alguns minutos! Assim que confirmar, te aviso. 😉`;
      } else {
        contextTitle = 'Lembrete de Pagamento';
        contextDesc = 'Envie caso o cliente tenha gerado Pix/Boleto e esquecido.';
        contextType = 'info';
        link = `${baseUrl}/#/pending?external_reference=${this.pedido.external_reference}`;
        message = `Oi ${firstName}! Tudo certo com seu pedido de *${produtoNome}*?\n\nVi que está pendente. Se precisar do código Pix novamente ou tiver dúvida, é só chamar!`;
      }
      
      this.shareData = { link, message, phoneNumber, contextTitle, contextDesc, contextType };
    },
    async copyToClipboard(text, successMessage) {
      try {
        await navigator.clipboard.writeText(text);
        AlertBus.$emit('show-alert', { message: successMessage, type: 'success' });
      } catch (e) {
        console.error(e);
        AlertBus.$emit('show-alert', { message: 'Erro ao copiar.', type: 'erro' });
      }
    },
    openWhatsApp() {
      if (!this.shareData) return;
      const url = `https://wa.me/${this.shareData.phoneNumber}?text=${encodeURIComponent(this.shareData.message)}`;
      window.open(url, '_blank');
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.share-content { display: flex; flex-direction: column; gap: 20px; }
.loading-state { padding: 20px; text-align: center; font-style: italic; color: var(--text-secondary); }

.context-box {
  display: flex; align-items: flex-start; gap: 15px; padding: 15px;
  border-radius: 8px; border: 1px solid; line-height: 1.4;
}
.context-box strong { display: block; margin-bottom: 5px; font-size: 1rem; }
.context-box p { margin: 0; font-size: 0.9rem; color: var(--text-main); }
.icon-context { font-size: 24px; margin-top: 2px; }

.context-box.review { background-color: rgba(255, 152, 0, 0.1); border-color: #FF9800; color: #FF9800; }
.context-box.success { background-color: rgba(76, 175, 80, 0.1); border-color: #4CAF50; color: #4CAF50; }
.context-box.warning { background-color: rgba(255, 152, 0, 0.1); border-color: #FF9800; color: #E65100; }
.context-box.info { border-color: var(--border-light); background-color: var(--bg-main); color: var(--text-secondary); }

.date-selector-container {
  background-color: var(--bg-main);
  border: 1px solid var(--border-light);
  padding: 10px 15px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.date-label {
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--color-accent);
  white-space: nowrap;
  flex-shrink: 0;
}

.custom-date-wrapper {
  position: relative;
  flex: 1;
  width: auto;
  min-width: 170px;
  max-width: 240px;
  height: 40px;
}

/* Input VISUAL (Texto) */
.input-date-display {
  width: 100%;
  height: 100%;
  padding: 0 35px 0 12px;
  border-radius: 6px;
  border: 1px solid var(--border-light);
  background-color: var(--bg-card);
  color: var(--text-main);
  font-family: inherit;
  box-sizing: border-box;
  font-size: 0.95rem;
  cursor: pointer;
  text-overflow: ellipsis;
}

/* Ícone */
.icon-calendar {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--text-secondary);
  font-size: 20px;
}

/* Input FUNCIONAL (Invisível) */
.input-date-hidden {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

/* HACK PARA PC (Chrome/Edge/Webkit):
   Expande o "gatilho" nativo do calendário para preencher todo o input.
   Isso garante que clicar em qualquer lugar da área abra o calendário.
*/
.input-date-hidden::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.message-preview {
  background-color: rgba(0,0,0,0.03);
  padding: 10px;
  border-radius: 6px;
  border: 1px dashed var(--border-light);
}
.message-preview small {
  display: block; margin-bottom: 5px; color: var(--text-secondary); font-size: 0.75rem; text-transform: uppercase; font-weight: bold;
}
.preview-box {
  white-space: pre-wrap;
  font-size: 0.85rem;
  color: var(--text-main);
  font-style: italic;
}

.share-actions-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; }

.share-option-btn {
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;
  padding: 15px 10px; background-color: var(--bg-main); border: 1px solid var(--border-light);
  border-radius: 8px; color: var(--text-main); cursor: pointer; transition: all 0.2s; height: 100%;
}
.share-option-btn:hover { border-color: var(--color-accent); background-color: var(--bg-icon-hover-light); transform: translateY(-2px); }
.share-option-btn span { font-size: 0.85rem; font-weight: 600; }
.share-option-btn .material-icons-outlined { font-size: 28px; color: var(--text-secondary); }

.share-option-btn.whatsapp { border-color: #25D366; background-color: rgba(37, 211, 102, 0.05); }
.share-option-btn.whatsapp .material-icons-outlined { color: #25D366; }
.share-option-btn.whatsapp:hover { background-color: rgba(37, 211, 102, 0.15); }

.modal-btn-no {
  padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem;
  background-color: var(--bg-icon-button); color: var(--text-main); border: 1px solid var(--border-light);
}
.modal-btn-no:hover { background-color: var(--bg-icon-button-hover); }

@media (max-width: 400px) {
  .date-label { font-size: 0.85rem; }
  .custom-date-wrapper { min-width: 140px; }
}

@media (max-width: 600px) {
  .share-actions-grid { grid-template-columns: 1fr; }
  .share-option-btn { flex-direction: row; justify-content: flex-start; padding: 15px; }
}
</style>